/* the product PDP v2 — gallery, tier ladder, accordion, hotspots, timeline */
(function () {
  "use strict";
  /* Every sw-* section includes this file with its own <script defer> tag, so the
     browser executes it once PER SECTION (9-10x on the PDP). Without this guard
     every handler binds N times: an even N makes the FAQ accordion toggle
     open->closed on a single click. Run the body once; later copies bail. */
  if (window.__swPdpLoaded) return;
  window.__swPdpLoaded = true;
  /* Appstle's app embed wraps BOTH window.fetch and XMLHttpRequest and rewrites
     /cart/add payloads to match its own (hidden) widget state — which silently
     strips the selling plan this buybox picked. A fresh same-origin iframe has
     an untouched fetch, so the request goes out exactly as built. */
  /* ---------- theme adapter ----------
     Selectors differ per theme. snippets/sw-tokens.liquid publishes the host
     theme's selectors on window.SW_THEME; each entry is a comma-separated
     fallback chain, so an unconfigured store still has a fair chance. */
  var SWT = (window.SW_THEME || {});
  function themeEl(key, fallback) {
    var sel = SWT[key] || fallback;
    if (!sel) return null;
    var list = sel.split(",");
    for (var i = 0; i < list.length; i++) {
      var el = document.querySelector(list[i].trim());
      if (el) return el;
    }
    return null;
  }
  function cartTrigger() {
    return themeEl("cartTrigger", '.wt-cart__trigger, .cart-trigger, [href$="/cart"], #cart-icon-bubble');
  }
  function menuTrigger() {
    return themeEl("menuTrigger", '.wt-header__menu-trigger, .header__menu-trigger, [aria-label*="menu" i]');
  }
  function cartDrawer() {
    return themeEl("cartDrawer", "cart-drawer");
  }
  function cartRefreshEvent() {
    return SWT.refreshEvent || "cart-drawer:refresh";
  }

  var _cleanFetch = null;
  function cleanFetch() {
    if (_cleanFetch) return _cleanFetch;
    try {
      var f = document.createElement("iframe");
      f.setAttribute("aria-hidden", "true");
      f.style.cssText = "position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none;";
      document.body.appendChild(f);
      var w = f.contentWindow;
      if (w && typeof w.fetch === "function" && w.fetch.toString().indexOf("[native code]") > -1) {
        _cleanFetch = w.fetch.bind(w);
        return _cleanFetch;
      }
    } catch (e) { /* fall through */ }
    _cleanFetch = window.fetch.bind(window);
    return _cleanFetch;
  }

  var money = function (cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || "${{amount}}").replace(/\{\{\s*amount\s*\}\}/, v);
  };

  /* ---------- gallery: peek rail, swipe + pointer drag ---------- */
  function gallery(root) {
    var rail = root.querySelector("[data-sw-rail]");
    var slides = root.querySelectorAll("[data-sw-slide]");
    if (!rail || !slides.length) return;

    function paint() {
      var w = slides[0].getBoundingClientRect().width + 10;
      var i = Math.round(rail.scrollLeft / w);
      rail.dataset.swIndex = i;
      /* the floating accent belongs to the lead packshot, not to every slide.
         The class is the NEGATIVE case so the accent stays visible if this
         never runs: a JS failure falls back to the old behaviour, not a
         missing element. */
      root.classList.toggle("sw-gal-off", i !== 0);
    }
    var ticking = false;
    rail.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });
    window.addEventListener("resize", paint);
    paint();

    // pointer drag for desktop mice; touch already scrolls natively
    var down = false, startX = 0, startScroll = 0, moved = 0;
    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return;
      down = true; moved = 0;
      startX = e.clientX; startScroll = rail.scrollLeft;
      rail.classList.add("is-dragging");
    });
    rail.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      rail.scrollLeft = startScroll - dx;
      if (moved > 4) e.preventDefault();
    });
    function release() {
      if (!down) return;
      down = false;
      rail.classList.remove("is-dragging");
      // snap to nearest slide once snapping is re-enabled
      var w = slides[0].getBoundingClientRect().width + 10;
      rail.scrollTo({ left: Math.round(rail.scrollLeft / w) * w, behavior: "smooth" });
    }
    rail.addEventListener("pointerup", release);
    rail.addEventListener("pointercancel", release);
    rail.addEventListener("pointerleave", release);
  }

  /* ---------- supplement facts modal ---------- */
  function factsModal(root) {
    var openBtn = root.querySelector("[data-sw-facts-open]");
    var modal = root.querySelector("[data-sw-modal]");
    if (!openBtn || !modal) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("sw-modal-open");
      var close = modal.querySelector("[data-sw-modal-close]");
      if (close) close.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove("sw-modal-open");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtn.addEventListener("click", open);
    modal.querySelectorAll("[data-sw-modal-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (!modal.hidden && (e.key === "Escape" || e.keyCode === 27)) close();
    });
  }

  /* ---------- ship-by date ----------
     Liquid already printed this in shop time. Recomputing in the browser keeps
     it honest across time zones and, more importantly, repairs it when Shopify
     serves the page from its render cache with yesterday's date baked in. */
  function shipBy(el) {
    var target = el.querySelector("[data-sw-ship-date]");
    if (!target) return;
    var days = parseInt(el.getAttribute("data-sw-ship-days"), 10);
    if (!days || days < 1) days = 3;
    var sat = el.getAttribute("data-sw-ship-sat") === "true";
    var d = new Date(), added = 0, guard = 0;
    while (added < days && guard++ < 40) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      /* Sunday never counts. Saturday counts only where the carrier runs it. */
      if (w !== 0 && (w !== 6 || sat)) added++;
    }
    try {
      target.textContent = d.toLocaleDateString(undefined, {
        weekday: "short", month: "short", day: "numeric"
      });
    } catch (e) {}
  }

  /* ---------- video review badge + lightbox ----------
     The <video> is never in the markup. It is constructed on the first open,
     so a shopper who does not tap the card pays for one poster image and no
     video bytes at all. The lightbox reuses the facts-modal body lock, which
     also parks the sticky ATC bar while it is up. */
  function videoReview(root) {
    var pop = root.querySelector("[data-sw-vpop]");
    var openers = root.querySelectorAll("[data-sw-vpop-open]");
    if (!pop || !openers.length) return;

    var stage = pop.querySelector("[data-sw-vpop-stage]");
    var soundBtn = pop.querySelector("[data-sw-vpop-sound]");
    var atcBtn = pop.querySelector("[data-sw-vpop-atc]");
    var nowEl = pop.querySelector("[data-sw-vpop-now]");
    var wasEl = pop.querySelector("[data-sw-vpop-was]");
    var src = stage ? stage.getAttribute("data-src") : "";
    if (!stage || !src) return;

    var video = null, lastFocus = null;

    function build() {
      if (video) return video;
      var v = document.createElement("video");
      v.className = "sw-vpop__video";
      v.setAttribute("playsinline", "");
      v.setAttribute("webkit-playsinline", "");
      v.playsInline = true;
      v.controls = true;
      v.preload = "auto";
      var poster = stage.getAttribute("data-poster");
      if (poster) v.poster = poster;
      function ready() { pop.classList.add("is-ready"); }
      /* let the film decide the frame: a portrait clip keeps the 9/16 stage,
         anything else re-shapes it instead of sitting in two black bars */
      v.addEventListener("loadedmetadata", function () {
        ready();
        if (v.videoWidth && v.videoHeight) {
          stage.style.aspectRatio = v.videoWidth + " / " + v.videoHeight;
        }
      });
      v.addEventListener("canplay", ready);
      v.addEventListener("error", ready);
      v.src = src;
      stage.appendChild(v);
      video = v;
      return v;
    }

    /* the lightbox sells the subscription Welcome Kit, so it puts the buybox on
       that tier first and then presses the real button: one add path, one place
       where the variant and the selling plan are decided. */
    function pickSub() {
      var found = null;
      document.querySelectorAll("[data-sw-tier]").forEach(function (i) {
        if (!found && !i.disabled && i.dataset.sellingPlan) found = i;
      });
      if (found && !found.checked) {
        found.checked = true;
        found.dispatchEvent(new Event("change", { bubbles: true }));
      }
      return found;
    }

    function syncPrice() {
      var now = document.querySelector("[data-sw-atc-now]");
      var was = document.querySelector("[data-sw-atc-was]");
      if (nowEl) nowEl.textContent = now ? now.textContent : "";
      if (wasEl) {
        wasEl.textContent = was ? was.textContent : "";
        wasEl.style.display = was && was.textContent ? "" : "none";
      }
    }

    function tabbable() {
      var out = [];
      pop.querySelectorAll("button,video,[href],[tabindex]").forEach(function (el) {
        if (el.hasAttribute("hidden") || el.disabled) return;
        if (el.getAttribute("tabindex") === "-1") return;
        out.push(el);
      });
      return out;
    }

    function onKey(e) {
      if (pop.hidden) return;
      if (e.key === "Escape" || e.keyCode === 27) { e.preventDefault(); close(); return; }
      if (e.key !== "Tab" && e.keyCode !== 9) return;
      var list = tabbable();
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      if (!pop.hidden) return;
      lastFocus = document.activeElement;
      pickSub();
      syncPrice();
      setTimeout(syncPrice, 60);
      pop.hidden = false;
      document.body.classList.add("sw-modal-open");

      var v = build();
      try { v.currentTime = 0; } catch (err) {}
      v.muted = false;
      /* the tap that opened the box is a user gesture, so sound normally plays.
         Where the browser still refuses, fall back to muted and offer the
         unmute chip rather than showing a frozen first frame. */
      var pr = v.play();
      if (pr && pr.catch) {
        pr.catch(function () {
          v.muted = true;
          if (soundBtn) soundBtn.hidden = false;
          var p2 = v.play();
          if (p2 && p2.catch) p2.catch(function () {});
        });
      }

      var x = pop.querySelector(".sw-vpop__x");
      if (x && x.focus) x.focus();
      document.addEventListener("keydown", onKey);
    }

    function close() {
      if (pop.hidden) return;
      pop.hidden = true;
      document.body.classList.remove("sw-modal-open");
      if (video) { try { video.pause(); } catch (err) {} }
      if (soundBtn) soundBtn.hidden = true;
      document.removeEventListener("keydown", onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openers.forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(); });
    });
    pop.querySelectorAll("[data-sw-vpop-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    if (soundBtn) {
      soundBtn.addEventListener("click", function () {
        if (!video) return;
        video.muted = false;
        soundBtn.hidden = true;
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {});
      });
    }
    if (atcBtn) {
      atcBtn.addEventListener("click", function () {
        var real = document.querySelector("[data-sw-atc]");
        if (!real) return;
        pickSub();
        /* close first: the theme drawer must not open behind a scrim, and the
           body scroll lock has to be off before it does */
        close();
        setTimeout(function () { real.click(); }, 70);
      });
    }
    document.querySelectorAll("[data-sw-tier]").forEach(function (i) {
      i.addEventListener("change", function () { setTimeout(syncPrice, 30); });
    });
  }

  /* ---------- subscribe toggle ----------
     A one-switch stand-in for the radio ladder. The radios still exist and are
     still what the ATC reads; the switch only flips them and re-fires change,
     so tiers(), paintOfferHero() and the gifts show/hide need no special case. */
  function subToggle(root) {
    var boxes = root.querySelectorAll("[data-sw-subtoggle]");
    if (!boxes.length) return;
    var input = root.querySelector("[data-sw-subtoggle-input]");
    var inputs = root.querySelectorAll("[data-sw-tier]");
    var on = null, off = null;
    inputs.forEach(function (i) {
      if (i.disabled) return;
      if (i.dataset.sellingPlan) { if (!on) on = i; }
      else if (!off) off = i;
    });
    var tiers = root.querySelector(".sw-tiers");
    /* Without one tier of each kind the switch has nothing to say. Drop it AND
       un-hide the cards, so a mis-set template degrades to the working ladder
       instead of to no way to choose at all. */
    if (!input || !on || !off) {
      boxes.forEach(function (b) { b.remove(); });
      if (tiers) tiers.classList.remove("sw-tiers--toggle");
      return;
    }
    if (tiers) tiers.classList.add("sw-tiers--toggle");

    input.addEventListener("change", function () {
      var want = input.checked ? on : off;
      want.checked = true;
      want.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function paintSubToggle(root, d) {
    /* The bar and its checklist are separate nodes when toggle_top is on, so
       everything here is looked up from the root and is-off goes on both. */
    var boxes = root.querySelectorAll("[data-sw-subtoggle]");
    if (!boxes.length) return;
    boxes.forEach(function (b) { b.classList.toggle("is-off", !d.sellingPlan); });

    var input = root.querySelector("[data-sw-subtoggle-input]");
    if (input) input.checked = !!d.sellingPlan;

    var sub = root.querySelector("[data-sw-subtoggle-sub]");
    if (sub) {
      sub.textContent = d.toggleSub || "";
      sub.style.display = d.toggleSub ? "" : "none";
    }
    var pill = root.querySelector("[data-sw-subtoggle-pill]");
    if (pill) {
      pill.textContent = d.togglePill || "";
      pill.style.display = d.togglePill ? "" : "none";
    }

    var list = root.querySelector("[data-sw-subtoggle-list]");
    if (!list) return;
    var parts = (d.subLines || "").split("|").map(function (s) { return s.trim(); }).filter(Boolean);
    list.textContent = "";
    parts.forEach(function (text) {
      var li = document.createElement("li");
      li.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M4 12.5l5.2 5L20 6.5"/></svg>';
      li.appendChild(document.createTextNode(text));
      list.appendChild(li);
    });
    list.style.display = parts.length ? "" : "none";
  }

  /* ---------- offer hero ----------
     Repaints the art, headline, price and note from whichever tier is selected.
     Every field falls back to the section-level markup, so a tier that sets none
     of the hero_* settings leaves the block exactly as Liquid rendered it. */
  function paintOfferHero(root, d) {
    var hero = root.querySelector("[data-sw-offerhero]");
    if (!hero) return;

    function put(sel, val) {
      var el = hero.querySelector(sel);
      if (!el) return;
      el.textContent = val || "";
      el.style.display = val ? "" : "none";
    }
    put("[data-sw-offerhero-was]", d.heroCompare);
    put("[data-sw-offerhero-now]", d.heroPrice || d.priceLabel);
    put("[data-sw-offerhero-unit]", d.heroUnit);
    put("[data-sw-offerhero-note]", d.heroNote);

    var title = hero.querySelector("[data-sw-offerhero-title]");
    if (title) {
      if (title.dataset.swDefault === undefined) title.dataset.swDefault = title.textContent;
      var t = d.heroTitle || title.dataset.swDefault || "";
      title.textContent = t;
      title.style.display = t ? "" : "none";
    }

    var img = hero.querySelector("[data-sw-offerhero-img]");
    if (img) {
      if (img.dataset.swDefault === undefined) img.dataset.swDefault = img.getAttribute("src") || "";
      var src = d.heroArt || img.dataset.swDefault;
      if (src && img.getAttribute("src") !== src) img.setAttribute("src", src);
    }

    hero.classList.toggle("is-onetime", !d.sellingPlan);
  }

  /* ---------- tier ladder ---------- */
  function tiers(root) {
    var inputs = root.querySelectorAll("[data-sw-tier]");
    var btnWas = root.querySelector("[data-sw-atc-was]");
    var btnNow = root.querySelector("[data-sw-atc-now]");
    var fmt = root.dataset.swMoneyFormat;
    if (!inputs.length) return;

    function apply(input) {
      var label = input.closest(".sw-tier");
      root.querySelectorAll(".sw-tier").forEach(function (l) { l.classList.remove("is-active"); });
      if (label) label.classList.add("is-active");
      var d = input.dataset;
      var form = root.querySelector("[data-sw-form]");
      if (form) form.setAttribute("data-sw-plan", d.sellingPlan ? "1" : "0");
      root.swSelection = {
        id: d.variantId || "",
        selling_plan: d.sellingPlan || "",
        quantity: parseInt(d.quantity || "1", 10) || 1
      };
      if (btnNow) btnNow.textContent = d.priceLabel || "";
      var dayEl = root.querySelector("[data-sw-atc-day]");
      var btn = root.querySelector("[data-sw-atc]");
      if (dayEl) {
        /* buy_polish hides the was/now pair on phones, so the separator moves to a
           CSS ::before that only the wide layout paints. Without the attribute the
           string is byte-identical to what every earlier view rendered. */
        var perDayOnly = btn && btn.dataset.swAtcPrice === "perday";
        dayEl.textContent = d.perDay ? (perDayOnly ? d.perDay : "\u00b7 " + d.perDay) : "";
        dayEl.style.display = d.perDay ? "" : "none";
      }
      if (btnWas) {
        btnWas.textContent = d.compareLabel || "";
        btnWas.style.display = d.compareLabel ? "" : "none";
      }
      paintOfferHero(root, d);
      paintSubToggle(root, d);
    }
    subToggle(root);
    inputs.forEach(function (input) {
      input.addEventListener("change", function () { if (input.checked) apply(input); });
    });
    var checked = root.querySelector("[data-sw-tier]:checked") || inputs[0];
    checked.checked = true;
    apply(checked);
  }

  /* ---------- add to cart ---------- */
  function atc(root) {
    var host = root.querySelector("[data-sw-form]");
    if (!host) return;
    var btn = host.querySelector("[data-sw-atc]");
    var err = root.querySelector("[data-sw-err]");
    if (!btn) return;

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.getAttribute("aria-disabled") === "true") return;
      var sel = root.swSelection;
      if (!sel || !sel.id) return;

      btn.setAttribute("aria-disabled", "true");
      if (err) err.classList.remove("is-on");

      var item = { id: Number(sel.id), quantity: sel.quantity || 1 };
      if (sel.selling_plan) item.selling_plan = Number(sel.selling_plan);

      cleanFetch()((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          btn.removeAttribute("aria-disabled");
          if (json.status && json.status !== 200) {
            if (err) {
              err.textContent = json.description || json.message || "Could not add to cart.";
              err.classList.add("is-on");
            }
            return;
          }
          document.dispatchEvent(new CustomEvent("sw:cart-added", { bubbles: true }));
          var drawer = cartDrawer();
          var trigger = cartTrigger();
          /* A theme that ships its own drawer may expose an opener global
             (window.openCart) and may not stamp data-cart-type at all. Prefer
             the global, then the element, and only redirect as a last resort:
             the strict cartType === "drawer" test sent such themes to /cart on
             every add. */
          var opener = typeof window.openCart === "function" ? window.openCart : null;
          var isDrawer = !!opener || (!!drawer && drawer.dataset.cartType !== "page");
          if (isDrawer && (opener || trigger)) {
            document.dispatchEvent(new CustomEvent(cartRefreshEvent(), { bubbles: true }));
            setTimeout(function () {
              if (drawer && drawer.hasAttribute("open")) return;
              if (opener) { try { opener(); return; } catch (e) {} }
              if (trigger) trigger.click();
            }, 260);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || "/cart";
          }
        })
        .catch(function () {
          btn.removeAttribute("aria-disabled");
          window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        });
    });
  }

  /* ---------- accordion ---------- */
  function accordion(root) {
    var items = root.querySelectorAll("[data-sw-acc-item]");
    items.forEach(function (item) {
      var btn = item.querySelector("[data-sw-acc-btn]");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        items.forEach(function (o) { o.classList.remove("is-open"); });
        if (!open) {
          item.classList.add("is-open");
          var img = item.dataset.swAccImage;
          if (img) {
            // two copies exist (desktop column + stacked inline); swap both
            root.querySelectorAll("[data-sw-acc-media]").forEach(function (t) {
              t.setAttribute("src", img);
            });
          }
        }
      });
    });
  }

  /* ---------- hotspots ---------- */
  function hotspots(root) {
    var dots = root.querySelectorAll("[data-sw-dot]");
    dots.forEach(function (dot) {
      var toggle = function () {
        var on = dot.classList.contains("is-on");
        dots.forEach(function (d) { d.classList.remove("is-on"); });
        if (!on) dot.classList.add("is-on");
      };
      dot.addEventListener("click", toggle);
      dot.addEventListener("mouseenter", function () {
        dots.forEach(function (d) { d.classList.remove("is-on"); });
        dot.classList.add("is-on");
      });
    });
  }

  /* ---------- card carousel arrows ---------- */
  function cards(root) {
    var rail = root.querySelector("[data-sw-cards]");
    if (!rail) return;
    var step = function () {
      var c = rail.querySelector(".sw-card");
      return c ? c.getBoundingClientRect().width + 14 : 260;
    };
    var prev = root.querySelector("[data-sw-cards-prev]");
    var next = root.querySelector("[data-sw-cards-next]");
    if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
  }

  /* ---------- timeline: sticky scrub on desktop, rail reveal on mobile ---------- */
  function timeline(root) {
    if (root.swTlBooted) return;
    root.swTlBooted = true;

    var scroller = root.querySelector("[data-sw-tl-scroll]");
    var cols = root.querySelectorAll("[data-sw-tl-col]");
    var dots = root.querySelectorAll("[data-sw-tl-dot]");
    var spine = root.querySelector("[data-sw-tl-spine]");
    if (!cols.length) return;

    var n = cols.length;
    var mq = window.matchMedia("(max-width: 759px)");
    // Liquid sets the scrub track height inline; remember it so the desktop
    // path can restore it instead of wiping it and collapsing the track
    var baseHeight = scroller ? scroller.style.height : "";

    /* ---- mobile: scrub each step against the reading line ---- */
    var rafPending = false, mobileScroll = null;
    function mobileOn() {
      if (scroller) scroller.style.height = "auto";

      function frame() {
        var vh = window.innerHeight;
        var line = vh * 0.78;      // where a step counts as "arrived"
        var span = vh * 0.34;      // how much scroll the reveal takes
        var sum = 0;
        for (var i = 0; i < n; i++) {
          var r = cols[i].getBoundingClientRect();
          var p = (line - r.top) / span;
          p = p < 0 ? 0 : (p > 1 ? 1 : p);
          cols[i].style.setProperty("--p", p.toFixed(3));
          cols[i].classList.toggle("is-on", p > 0.5);
          sum += p;
        }
        if (spine) spine.style.height = ((sum / n) * 100).toFixed(2) + "%";
      }

      mobileScroll = function () {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () { frame(); rafPending = false; });
      };
      window.addEventListener("scroll", mobileScroll, { passive: true });
      window.addEventListener("resize", mobileScroll);
      frame();
    }

    /* ---- desktop: scrub the sticky stage ---- */
    var scrollHandler = null;
    function desktopOn() {
      if (!scroller) return;
      scroller.style.height = baseHeight;
      function paint() {
        var r = scroller.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        if (total <= 0) {
          cols.forEach(function (c) { c.classList.add("is-on"); });
          dots.forEach(function (d) { d.classList.add("is-on"); });
          return;
        }
        var p = Math.min(1, Math.max(0, -r.top / total));
        var active = Math.min(n - 1, Math.floor(p * n + 0.0001));
        cols.forEach(function (c, i) { c.classList.toggle("is-on", i <= active); });
        dots.forEach(function (d, i) { d.classList.toggle("is-on", i <= active); });
      }
      var ticking = false;
      scrollHandler = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { paint(); ticking = false; });
      };
      window.addEventListener("scroll", scrollHandler, { passive: true });
      window.addEventListener("resize", paint);
      paint();
    }

    function teardown() {
      if (mobileScroll) {
        window.removeEventListener("scroll", mobileScroll);
        window.removeEventListener("resize", mobileScroll);
        mobileScroll = null;
      }
      if (scrollHandler) { window.removeEventListener("scroll", scrollHandler); scrollHandler = null; }
      cols.forEach(function (c) { c.style.removeProperty("--p"); });
      cols.forEach(function (c) { c.classList.remove("is-on"); });
      dots.forEach(function (d) { d.classList.remove("is-on"); });
      if (spine) spine.style.height = "";
    }
    function apply() {
      teardown();
      if (mq.matches) mobileOn(); else desktopOn();
    }
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  /* ---------- ingredient story popup ---------- */
  function ingredientStory(root) {
    if (root.swStoryBooted) return;
    root.swStoryBooted = true;

    var openBtn = root.querySelector("[data-sw-ing-open]");
    var modal = root.querySelector("[data-sw-ing-modal]");
    if (!openBtn || !modal) return;

    var track = modal.querySelector("[data-sw-story-track]");
    var slides = modal.querySelectorAll("[data-sw-story-slide]");
    var bars = modal.querySelectorAll(".sw-story__bar");
    var cue = modal.querySelector("[data-sw-story-cue]");
    var priceEl = modal.querySelector("[data-sw-story-price]");
    var atc = modal.querySelector("[data-sw-story-atc]");
    var lastFocus = null;

    function step() {
      return slides.length ? slides[0].getBoundingClientRect().height : 1;
    }
    function paint() {
      var i = Math.round(track.scrollTop / step());
      bars.forEach(function (b, k) {
        b.classList.toggle("is-done", k < i);
        b.classList.toggle("is-on", k === i);
      });
      if (cue) cue.classList.toggle("is-off", i > 0);
    }
    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });

    function go(dir) {
      var i = Math.round(track.scrollTop / step()) + dir;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ top: i * step(), behavior: "smooth" });
    }
    var prev = modal.querySelector("[data-sw-story-prev]");
    var next = modal.querySelector("[data-sw-story-next]");
    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });

    // mirror the buybox's live price onto the popup button
    function syncPrice() {
      if (!priceEl) return;
      var now = document.querySelector("[data-sw-atc-now]");
      priceEl.textContent = now ? now.textContent : "";
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("sw-modal-open");
      track.scrollTop = 0;
      syncPrice();
      paint();
      var c = modal.querySelector("[data-sw-ing-close]");
      if (c && c.focus) c.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove("sw-modal-open");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtn.addEventListener("click", open);
    modal.querySelectorAll("[data-sw-ing-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (modal.hidden) return;
      if (e.key === "Escape" || e.keyCode === 27) close();
      if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); go(1); }
      if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); go(-1); }
    });

    // the buybox owns the cart logic (tier, selling plan, clean fetch, drawer):
    // proxy the click rather than duplicating any of it
    if (atc) {
      atc.addEventListener("click", function () {
        var real = document.querySelector("[data-sw-atc]");
        close();
        if (real) { real.click(); return; }
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      });
    }
  }

  /* ---------- sticky pill bar ---------- */
  function stickyBar(bar) {
    if (bar.swBooted) return;
    bar.swBooted = true;

    var after = parseInt(bar.dataset.swShowAfter || "420", 10);
    var countEl = bar.querySelector("[data-sw-cart-count]");
    var cartBtn = bar.querySelector("[data-sw-sticky-cart]");
    var menuBtn = bar.querySelector("[data-sw-sticky-menu]");

    /* pinned mode: the bar is the header and is always in. Leave is-on alone,
       or the scroll handler strips the class the moment the page is at top. */
    var pinned = bar.dataset.swPinned === "true";

    if (pinned) {
      /* The bar is out of flow, so the spacer has to hold its height. Measuring
         once on boot races the ticker's own layout and the webfont swap, and a
         short spacer leaves page content hidden underneath a fixed header.
         Observe the bar instead so the spacer can never drift out of step. */
      var syncHeight = function () {
        document.documentElement.style.setProperty("--sw-sticky-h", bar.offsetHeight + "px");
      };
      syncHeight();
      window.addEventListener("resize", syncHeight, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeight).catch(function () {});
      if (window.ResizeObserver) {
        try { new ResizeObserver(syncHeight).observe(bar); } catch (e) {}
      } else {
        setTimeout(syncHeight, 400);
        setTimeout(syncHeight, 1500);
      }
    }

    function paint() {
      if (pinned) return;
      var on = window.scrollY > after;
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
      // lift the storewide header out while ours is in, so only one bar shows
      document.body.classList.toggle("sw-sticky-on", on);
    }
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });
    paint();

    var last = null;
    function setCount(n) {
      if (!countEl) return;
      countEl.textContent = n;
      if (last !== null && n !== last && cartBtn) {
        cartBtn.classList.remove("is-bumped");
        void cartBtn.offsetWidth;
        cartBtn.classList.add("is-bumped");
      }
      last = n;
    }
    function refresh() {
      cleanFetch()("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }
    refresh();
    document.addEventListener(cartRefreshEvent(), function () { setTimeout(refresh, 400); });
    document.addEventListener("sw:cart-added", function () { setTimeout(refresh, 300); });

    if (menuBtn) {
      menuBtn.addEventListener("click", function () {
        var t = menuTrigger();
        if (t) t.click();
      });
    }
    if (cartBtn) {
      cartBtn.addEventListener("click", function () {
        /* in pinned mode the theme's own header is hidden, so its cart icon may
           not be clickable. Prefer the theme's opener global when it exposes one. */
        if (typeof window.openCart === "function") { try { window.openCart(); return; } catch (e) {} }
        var t = cartTrigger();
        if (t) { t.click(); return; }
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      });
    }
  }

  /* ---------- sticky bottom add-to-cart ---------- */
  function stickyAtc(bar) {
    if (bar.swBooted) return;
    bar.swBooted = true;

    var realAtc = document.querySelector("[data-sw-atc]");
    if (!realAtc) return;

    var nowEl = bar.querySelector("[data-sw-satc-now]");
    var wasEl = bar.querySelector("[data-sw-satc-was]");
    var tierEl = bar.querySelector("[data-sw-satc-tier]");
    var addBtn = bar.querySelector("[data-sw-satc-add]");
    var jumpBtn = bar.querySelector("[data-sw-satc-scroll]");

    // mirror whatever the buybox currently has selected
    function sync() {
      var now = document.querySelector("[data-sw-atc-now]");
      var was = document.querySelector("[data-sw-atc-was]");
      if (nowEl) nowEl.textContent = now ? now.textContent : "";
      if (wasEl) {
        wasEl.textContent = was ? was.textContent : "";
        wasEl.style.display = was && was.textContent ? "" : "none";
      }
      if (tierEl) {
        var active = document.querySelector(".sw-tier.is-active .sw-tier__name");
        tierEl.textContent = active ? active.textContent.trim() : "";
      }
    }
    sync();
    document.querySelectorAll("[data-sw-tier]").forEach(function (i) {
      i.addEventListener("change", function () { setTimeout(sync, 30); });
    });

    /* The buybox fills [data-sw-atc-now] after this bar has already booted, and
       until now the only other thing that called sync() was a tier change. A
       shopper who never switches tier therefore saw the bar with a button and
       no price, at every scroll depth. Watch the price node instead of reading
       it once. Opt-in per view so the older templates keep their exact
       behaviour. */
    if (bar.dataset.swSatcLive === "true" && window.MutationObserver) {
      var priceSrc = document.querySelector("[data-sw-atc-now]");
      if (priceSrc) {
        new MutationObserver(function () { sync(); }).observe(priceSrc, {
          childList: true, characterData: true, subtree: true
        });
      }
    }

    // show it only once the real button has scrolled out of view
    function show(on) {
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
    }

    /* Opt-in early mode. The default gating hides the bar until the real button
       has gone past, which on a phone is most of two screens down: the shopper
       most likely to leave is exactly the one who never sees a price or a way
       to buy. With a pixel threshold set, the bar behaves like an ordinary
       scroll bar instead, and hides again near the real button so the two are
       never on screen together. */
    /* always_on is the same early mode with no scroll threshold at all: the bar
       is on from the first pixel and still steps aside whenever the real button
       is on screen. after = -1 rather than 0 so the comparison below stays a
       strict > and the templates that set a real threshold keep the exact
       behaviour they had. */
    var alwaysOn = bar.dataset.swSatcAlways === "true";
    var after = alwaysOn ? -1 : parseInt(bar.dataset.swSatcAfter || "0", 10);
    if (alwaysOn || after > 0) {
      var tick = false;
      var paintEarly = function () {
        var r = realAtc.getBoundingClientRect();
        var realVisible = r.top < window.innerHeight && r.bottom > 0;
        show(window.scrollY > after && !realVisible);
      };
      window.addEventListener("scroll", function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(function () { paintEarly(); tick = false; });
      }, { passive: true });
      paintEarly();
      if (addBtn) addBtn.addEventListener("click", function () { realAtc.click(); });
      if (jumpBtn) {
        jumpBtn.addEventListener("click", function () {
          var box0 = document.querySelector("[data-sw-buybox]") || realAtc;
          box0.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }
      return;
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = e.boundingClientRect.top < 0;
          show(!e.isIntersecting && past);
        });
      }, { rootMargin: "0px 0px -10% 0px", threshold: 0 });
      io.observe(realAtc);
    } else {
      var ticking = false;
      window.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var r = realAtc.getBoundingClientRect();
          show(r.bottom < 0);
          ticking = false;
        });
      }, { passive: true });
    }

    if (addBtn) addBtn.addEventListener("click", function () { realAtc.click(); });
    if (jumpBtn) {
      jumpBtn.addEventListener("click", function () {
        var box = document.querySelector("[data-sw-buybox]") || realAtc;
        box.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }

  /* ---------- review card that types itself in ---------- */
  function typer(card) {
    if (card.swTyped) return;
    card.swTyped = true;

    var target = card.querySelector("[data-sw-type]");
    if (!target) return;

    var text = target.textContent;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) { card.classList.add("is-typed"); return; }

    // one span per character, so the reveal can walk the line like a cursor
    var frag = document.createDocumentFragment();
    var spans = [];
    for (var i = 0; i < text.length; i++) {
      var ch = document.createElement("span");
      ch.className = "sw-ch";
      ch.textContent = text[i];
      // pre-wrap, not pre: "pre" preserves the space but kills the line-break
      // opportunity at it. With every space wrapped this way the quote becomes one
      // unbreakable line and pushes the whole page into horizontal overflow.
      if (text[i] === " ") ch.style.whiteSpace = "pre-wrap";
      frag.appendChild(ch);
      spans.push(ch);
    }
    target.textContent = "";
    target.appendChild(frag);

    var caret = card.querySelector(".sw-hrev__caret");
    function run() {
      card.classList.add("is-typing");
      var i = 0;
      var perChar = Math.max(7, Math.min(18, 2600 / spans.length));
      var last = 0;
      function step(ts) {
        if (!last) last = ts;
        var due = Math.floor((ts - last) / perChar);
        while (i <= due && i < spans.length) {
          spans[i].style.opacity = "1";
          spans[i].style.filter = "none";
          // keep the caret travelling with the last lit character
          if (caret && spans[i].parentNode) {
            var r = spans[i];
            caret.style.transform = "none";
          }
          i++;
        }
        if (i < spans.length) {
          requestAnimationFrame(step);
        } else {
          card.classList.remove("is-typing");
          card.classList.add("is-typed");
        }
      }
      requestAnimationFrame(step);
    }

    if (!("IntersectionObserver" in window)) { run(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        run();
      });
    }, { rootMargin: "0px 0px -18% 0px", threshold: 0.25 });
    io.observe(card);
  }

  /* ---------- preview avatars on the Yotpo list ----------
     Yotpo renders its list client-side and ships a grey silhouette when a
     reviewer has no photo. This paints the supplied portraits onto those
     placeholders so the layout can be judged with faces in place. */
  function reviewAvatars(root) {
    if (root.swAvaBooted) return;
    root.swAvaBooted = true;

    var files = (root.dataset.swAvatars || "").split("|").filter(Boolean);
    if (!files.length) return;

    function paint() {
      var holders = root.querySelectorAll(
        '[class*="avatar" i]:not([data-sw-ava]),[class*="initials" i]:not([data-sw-ava])'
      );
      var n = 0;
      holders.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width < 18 || r.width > 90) return;   // avatar-sized only
        el.setAttribute("data-sw-ava", "1");
        el.style.backgroundImage = "url(" + files[n % files.length] + ")";
        el.style.backgroundSize = "cover";
        el.style.backgroundPosition = "center";
        el.style.borderRadius = "50%";
        el.style.color = "transparent";
        n++;
      });
      return n;
    }
    paint();
    if (!("MutationObserver" in window)) return;
    var mo = new MutationObserver(function () { paint(); });
    mo.observe(root, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  /* ---------- review list: reveal the rest ---------- */
  function reviewList(root) {
    if (root.swRvwBooted) return;
    root.swRvwBooted = true;
    var btn = root.querySelector("[data-sw-reviews-more]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      root.querySelectorAll("[data-sw-review].is-hidden").forEach(function (el) {
        el.classList.remove("is-hidden");
      });
      btn.remove();
    });
  }

  /* ---------- photo reviews: snap rail + review lightbox ----------
     The rail scrolls natively with no JS. Everything here is additive:
     arrows, the progress bar, drag-to-scroll on desktop, and the pop-up that
     carries the full review text the card only teases. */
  function photoReviews(root) {
    if (root.swPrBooted) return;
    root.swPrBooted = true;

    var rail = root.querySelector("[data-sw-pr-rail]");
    if (!rail) return;
    var cells = [].slice.call(rail.querySelectorAll(".sw-pr__cell"));
    if (!cells.length) return;

    var prev = root.querySelector("[data-sw-pr-prev]");
    var next = root.querySelector("[data-sw-pr-next]");
    var prog = root.querySelector("[data-sw-pr-prog]");

    /* measure from two cells rather than trusting the CSS gap value, so the
       step stays right if the gap ever changes at a breakpoint */
    function step() {
      var a = cells[0].getBoundingClientRect();
      if (cells[1]) return cells[1].getBoundingClientRect().left - a.left;
      return a.width + 14;
    }
    function page() {
      var s = step();
      if (s <= 0) return 1;
      return Math.max(1, Math.floor(rail.clientWidth / s) - 1);
    }
    function maxScroll() { return rail.scrollWidth - rail.clientWidth; }

    var pending = false;
    function sync() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var max = maxScroll();
        var p = max > 0 ? rail.scrollLeft / max : 0;
        if (prog) {
          /* the thumb's width is the visible share of the rail, so it doubles
             as a "how much is left" read, not just a position dot */
          var share = rail.scrollWidth > 0 ? rail.clientWidth / rail.scrollWidth : 1;
          if (share > 1) share = 1;
          prog.style.width = (share * 100) + "%";
          var travel = share > 0 ? ((1 - share) / share) * 100 : 0;
          prog.style.transform = "translateX(" + (p * travel) + "%)";
        }
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
      });
    }
    rail.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();

    if (prev) prev.addEventListener("click", function () {
      rail.scrollBy({ left: -step() * page(), behavior: "smooth" });
    });
    if (next) next.addEventListener("click", function () {
      rail.scrollBy({ left: step() * page(), behavior: "smooth" });
    });

    /* ---- autoplay: creep the rail until she touches it ----
       Opt-in per view. Native mandatory snap fights a continuous scrollLeft, so
       snap is turned off while this runs and restored the moment it stops. */
    var autoOn = root.dataset.swPrAuto === "true";
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (autoOn && !reduceMotion && cells.length > 1) {
      var creep = parseFloat(root.dataset.swPrSpeed || "34");
      if (!(creep > 0)) creep = 34;
      var raf = 0, lastTs = 0, rewinding = false, autoStopped = false, seen = true;
      var snapWas = rail.style.scrollSnapType;
      var pos = rail.scrollLeft;
      rail.style.scrollSnapType = "none";

      function stopAuto() {
        if (autoStopped) return;
        autoStopped = true;
        if (raf) cancelAnimationFrame(raf);
        rail.style.scrollSnapType = snapWas;
      }

      function creepTick(ts) {
        if (autoStopped) return;
        raf = requestAnimationFrame(creepTick);
        if (!seen || document.hidden) { lastTs = 0; return; }
        if (!lastTs) { lastTs = ts; pos = rail.scrollLeft; return; }
        var dt = (ts - lastTs) / 1000;
        lastTs = ts;
        /* a backgrounded tab hands back a huge delta; clamp it or the rail lurches */
        if (dt > 0.25) dt = 0.25;
        if (rewinding) return;
        var max = maxScroll();
        if (max <= 0) return;
        if (pos >= max - 1) {
          /* rewind rather than clone the cards: duplicated reviewer names on a
             page selling credibility is a worse cost than one slow rewind, and
             at this speed she reaches the end only after a minute-plus */
          rewinding = true;
          rail.scrollTo({ left: 0, behavior: "smooth" });
          setTimeout(function () { rewinding = false; pos = 0; lastTs = 0; }, 700);
          return;
        }
        pos += creep * dt;
        rail.scrollLeft = pos;
      }

      /* click, and the first move of a drag, stop it for good. Hover does NOT:
         a rail that freezes under the pointer reads as broken. */
      rail.addEventListener("pointerdown", stopAuto);
      rail.addEventListener("wheel", stopAuto, { passive: true });
      root.addEventListener("click", stopAuto);

      if ("IntersectionObserver" in window) {
        seen = false;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { seen = e.isIntersecting; });
        }, { threshold: 0.15 }).observe(rail);
      }
      raf = requestAnimationFrame(creepTick);
    }

    /* ---- drag to scroll (desktop pointers; touch already does this) ---- */
    var down = false, startX = 0, startScroll = 0, dragged = false, lastDragEnd = 0;
    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return;
      if (e.pointerType === "mouse" && e.button !== 0) return;
      down = true; dragged = false;
      startX = e.clientX; startScroll = rail.scrollLeft;
    });
    rail.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) < 6) return;
      dragged = true;
      rail.classList.add("is-dragging");
      rail.scrollLeft = startScroll - dx;
    });
    function release() {
      if (!down) return;
      down = false;
      if (!dragged) return;
      rail.classList.remove("is-dragging");
      /* snap-type is off while dragging, so settle by hand */
      var s = step();
      if (s > 0) rail.scrollTo({ left: Math.round(rail.scrollLeft / s) * s, behavior: "smooth" });
      lastDragEnd = Date.now();
    }
    rail.addEventListener("pointerup", release);
    rail.addEventListener("pointercancel", release);
    rail.addEventListener("pointerleave", release);

    /* ---- lightbox ---- */
    var lb = root.querySelector("[data-sw-pr-lb]");
    var panels = lb ? [].slice.call(lb.querySelectorAll("[data-sw-pr-panel]")) : [];
    var counter = lb ? lb.querySelector("[data-sw-pr-i]") : null;
    var closeBtn = lb ? lb.querySelector(".sw-pr__lb-x") : null;
    var cur = 0, lastFocus = null;

    function show(i) {
      if (!panels.length) return;
      cur = ((i % panels.length) + panels.length) % panels.length;
      panels.forEach(function (p, k) { p.hidden = k !== cur; });
      if (counter) counter.textContent = cur + 1;
    }
    function openLb(i) {
      if (!lb) return;
      lastFocus = document.activeElement;
      show(i);
      lb.hidden = false;
      document.body.classList.add("sw-pr-lock");
      if (closeBtn) closeBtn.focus();
    }
    function closeLb() {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      document.body.classList.remove("sw-pr-lock");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (lb) {
      lb.querySelectorAll("[data-sw-pr-close]").forEach(function (el) {
        el.addEventListener("click", closeLb);
      });
      var lbPrev = lb.querySelector("[data-sw-pr-lbprev]");
      var lbNext = lb.querySelector("[data-sw-pr-lbnext]");
      if (lbPrev) lbPrev.addEventListener("click", function () { show(cur - 1); });
      if (lbNext) lbNext.addEventListener("click", function () { show(cur + 1); });

      document.addEventListener("keydown", function (e) {
        if (lb.hidden) return;
        if (e.key === "Escape") { e.preventDefault(); closeLb(); return; }
        if (e.key === "ArrowLeft") { e.preventDefault(); show(cur - 1); return; }
        if (e.key === "ArrowRight") { e.preventDefault(); show(cur + 1); return; }
        if (e.key !== "Tab") return;
        /* keep Tab inside the dialog while it owns the screen */
        var f = [].slice.call(lb.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"))
          .filter(function (el) { return el.offsetParent !== null && !el.disabled; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    cells.forEach(function (cell) {
      var btn = cell.querySelector("[data-sw-pr-open]");
      if (!btn) return;
      btn.addEventListener("click", function (e) {
        /* a drag that ends over a card must not also count as a click */
        if (Date.now() - lastDragEnd < 220) { e.preventDefault(); return; }
        openLb(parseInt(btn.getAttribute("data-sw-pr-open"), 10) || 0);
      });
    });
  }


  /* ---------- announcement bar countdown ----------
     The window is per visitor and PERSISTED, so a refresh does not hand the
     same person a fresh three hours. When it elapses the bar drops the clock
     and shows the expired line; it never silently restarts, which is the thing
     that makes these obviously fake. localStorage is wrapped because private
     mode and blocked site data both throw on access, not on read. */
  function announce(el) {
    var hrs = parseFloat(el.dataset.swAnncHours);
    if (!(hrs > 0)) hrs = 3;
    var key = "sw-annc:" + (el.dataset.swAnncKey || "default");
    var span = hrs * 3600000;

    function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

    var end = parseInt(read(key) || "", 10);
    var now = Date.now();
    /* a stored deadline further out than the whole window means the clock was
       tampered with or the setting shrank; restart rather than show nonsense */
    if (!end || isNaN(end) || end - now > span) { end = now + span; store(key, String(end)); }

    var dEl = el.querySelector("[data-sw-annc-d]");
    var dUnit = el.querySelector('[data-sw-annc-unit="d"]');
    var dSep = el.querySelector('[data-sw-annc-sep="d"]');
    var hEl = el.querySelector("[data-sw-annc-h]");
    var mEl = el.querySelector("[data-sw-annc-m]");
    var sEl = el.querySelector("[data-sw-annc-s]");
    var clock = el.querySelector("[data-sw-annc-clock]");
    var txt = el.querySelector("[data-sw-annc-txt]");
    var over = el.dataset.swAnncOver || "";
    var timer = null;

    function pad(n) { return n < 10 ? "0" + n : String(n); }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        if (timer) { clearInterval(timer); timer = null; }
        if (clock) clock.hidden = true;
        if (over && txt) txt.textContent = over;
        el.setAttribute("data-sw-annc-state", "over");
        if (!over) el.hidden = true;
        return;
      }
      var t = Math.floor(left / 1000);
      /* The days slot is shown only for a window that can actually reach a day.
         A permanent "00 DAYS" on a three-hour timer reads as padding. */
      if (showDays) {
        if (dEl) dEl.textContent = pad(Math.floor(t / 86400));
        if (hEl) hEl.textContent = pad(Math.floor(t / 3600) % 24);
      } else if (hEl) {
        hEl.textContent = pad(Math.floor(t / 3600));
      }
      if (mEl) mEl.textContent = pad(Math.floor(t / 60) % 60);
      if (sEl) sEl.textContent = pad(t % 60);
    }

    var showDays = hrs >= 24;
    if (showDays) {
      if (dUnit) dUnit.hidden = false;
      if (dSep) dSep.hidden = false;
    }

    /* When the bar sits in normal flow (outside the fixed header), the header
       has to start BELOW it and slide up as the bar scrolls away, otherwise the
       fixed header covers the bar at the top of the page. Inline transform wins
       over the stylesheet rule, and the transition is killed so the header does
       not lag a fifth of a second behind the scroll. */
    var fixedBar = document.querySelector(".sw-stickybar--pinned");
    if (fixedBar && !fixedBar.contains(el)) {
      fixedBar.style.transition = "none";
      var raf = 0;
      var place = function () {
        raf = 0;
        var hgt = el.hidden ? 0 : el.getBoundingClientRect().height;
        var off = Math.max(0, hgt - (window.pageYOffset || document.documentElement.scrollTop || 0));
        fixedBar.style.transform = "translateY(" + off + "px)";
      };
      var onScroll = function () { if (!raf) raf = requestAnimationFrame(place); };
      addEventListener("scroll", onScroll, { passive: true });
      addEventListener("resize", onScroll);
      if (window.ResizeObserver) new ResizeObserver(onScroll).observe(el);
      place();
    }

    tick();
    el.hidden = false;
    if (el.getAttribute("data-sw-annc-state") !== "over") {
      timer = setInterval(tick, 1000);
      /* a backgrounded tab throttles setInterval, so resync on return */
      document.addEventListener("visibilitychange", function () {
        if (!document.hidden) tick();
      });
    }
  }

  function boot(scope) {
    var d = scope || document;
    // each step is isolated: one section throwing must not stop the rest,
    // and the sticky bar goes first because it owns the header handoff
    // boot() is called more than once per page (deferred copies of this file,
    // sw-reviews-hero calls SWPDP.boot(document), section:load in the editor),
    // so every root is bound at most once per selector. Without this the FAQ
    // accordion toggled open->closed on one click (2 listeners per button).
    function run(sel, fn) {
      try {
        d.querySelectorAll(sel).forEach(function (el) {
          var done = el.__swBooted || (el.__swBooted = {});
          if (done[sel]) return;
          done[sel] = true;
          try { fn(el); } catch (e) { if (window.console) console.warn("sw-pdp:", sel, e); }
        });
      } catch (e) { if (window.console) console.warn("sw-pdp:", sel, e); }
    }
    run("[data-sw-annc]", announce);
    run("[data-sw-stickybar]", stickyBar);
    run("[data-sw-stickyatc]", stickyAtc);
    run("[data-sw-buybox]", function (r) {
      if (r.swBooted) return;   // 4 script tags on the page; bind once
      r.swBooted = true;
      [gallery, tiers, atc, factsModal, videoReview].forEach(function (fn) {
        try { fn(r); } catch (e) { if (window.console) console.warn("sw-pdp buybox:", fn.name, e); }
      });
    });
    run("[data-sw-accordion]", accordion);
    run("[data-sw-typer]", typer);
    run("[data-sw-avatars]", reviewAvatars);
    run("[data-sw-reviews]", reviewList);
    run("[data-sw-photorail]", photoReviews);
    run("[data-sw-hotspots]", function (r) { hotspots(r); cards(r); });
    run("[data-sw-ing-modal]", function (m) {
      var host = m.closest(".shopify-section") || m.parentElement;
      if (host) ingredientStory(host);
    });
    run("[data-sw-timeline]", timeline);
    run("[data-sw-ship]", shipBy);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  window.SWPDP = { boot: boot, money: money };
})();
